import { render, staticRenderFns } from "./ClassifierValuesList.vue?vue&type=template&id=089b5e97&scoped=true&lang=pug&"
import script from "./ClassifierValuesList.vue?vue&type=script&lang=js&"
export * from "./ClassifierValuesList.vue?vue&type=script&lang=js&"
import style0 from "./ClassifierValuesList.vue?vue&type=style&index=0&id=089b5e97&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089b5e97",
  null
  
)

/* custom blocks */
import block0 from "./ClassifierValuesList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports